import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Drawflow, { DrawflowConnection } from 'drawflow';
import { FlowScriptResponse } from 'src/app/models/responses/flowScript';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-flow-draw',
  templateUrl: './flow-draw.component.html',
  styleUrls: ['./flow-draw.component.scss']
})
export class FlowDrawComponent implements OnInit, AfterViewInit, OnChanges {

  flowchart: Drawflow & { createCurvature?: any, contextmenu?: any, nodeId?: number } | undefined;
  // flowchart: any;
  overlayBox: any
  selectedConnection: any
  // addedNodeList: { item: FlowScriptResponse, pos_x: number, pos_y: number }[] = []


  @Input() Nodes: { item: FlowScriptResponse, pos_x: number, pos_y: number, nodeId: number }[] = []
  @Input() flowImportObject: string = ''
  @Input() flowTitle: string = ''
  @Input() titleClass: string = ''
  @Input() runlock: boolean = false
  @Input() loaderValue: number = 0

  @Output() SaveFlowEmitter: EventEmitter<any> = new EventEmitter<any>()
  @Output() NodeRemovedEmitter: EventEmitter<any> = new EventEmitter<any>()

  @Output() runFlowEmitter: EventEmitter<any> = new EventEmitter<any>()

  @Output() onImport: EventEmitter<any> = new EventEmitter<any>()
  @Output() clearFunction: EventEmitter<any> = new EventEmitter<any>()


  @Output() connectionSelected: EventEmitter<any> = new EventEmitter<any>()
  @Output() connectionRemove: EventEmitter<any> = new EventEmitter<any>()

  @Output() NodeSettingSelected: EventEmitter<any> = new EventEmitter<any>()
  @Output() getExecutionLogFunc: EventEmitter<any> = new EventEmitter<any>()

  @Output() stopButtonFunction: EventEmitter<any> = new EventEmitter<any>()




  constructor(private translate: TranslateService, private router: Router) { }

  ngOnInit() {


  }

  ngAfterViewInit() {
    this.initDrawFlow();

    this.flowchart.editor_mode = 'edit'; // Default
    this.flowchart.zoom_out()
    this.flowchart.zoom_out()
    this.flowchart.zoom_out()

    this.initExistFlow()
    // this.flowchart.editor_mode = 'fixed';
  }


  initExistFlow() {
    if (this.flowImportObject !== '') {
      var flowJson = JSON.parse(this.flowImportObject)

      if (this.flowchart && flowJson.flow) {
        this.flowchart.import(flowJson.flow)
      }
    }
  }

  clearFlow() {
    // this.flowchart.clear()
    this.clearFunction.emit()
  }


  setHtmlForNode(e: { html: HTMLObjectElement, id: string }) {

    Object.keys(this.flowchart.drawflow.drawflow.Home.data).map(item => {


      if (item == e.id.split('-')[1]) {
        this.flowchart.drawflow.drawflow.Home.data[item].html = e.html.outerHTML
      }
    })
  }


  flowChartClick(e) {
    if (e.target.classList[0] === 'parameter-button') {

      var selectedNodeId = e.target.closest('.drawflow_content_node').parentElement.id
      var selectedNode = this.flowchart.drawflow.drawflow.Home.data[`${selectedNodeId.slice(5)}`];

      this.flowchart.editor_mode = 'fixed'
      this.NodeSettingSelected.emit({ selectedNode: selectedNode, selectedNodeId: selectedNodeId, flowData: this.flowchart.drawflow.drawflow.Home.data, type: 'parameter', drawFlowExport: this.flowchart.export() });
      setTimeout(() => {
        this.flowchart.editor_mode = 'edit';

      }, 1000);
    } else if (e.target.classList[0] == "script-edit-button") {
      var selectedNodeId = e.target.closest('.drawflow_content_node').parentElement.id
      var selectedNode = this.flowchart.drawflow.drawflow.Home.data[`${selectedNodeId.slice(5)}`];
      this.flowchart.editor_mode = 'fixed'
      this.NodeSettingSelected.emit({
        selectedNode: selectedNode,
        selectedNodeId: selectedNodeId,
        flowData: this.flowchart.drawflow.drawflow.Home.data,
        type: 'script-edit',
        Nodefunction: (e) => this.setHtmlForNode(e),
        drawFlowExport: this.flowchart.export()
      });


      setTimeout(() => {
        this.flowchart.editor_mode = 'edit';

      }, 1000);
    } else if (e.target.classList[0] === "main-path") {
      setTimeout(() => {
        this.showConextMenu(e.clientX, e.clientY);
      }, 25);

    } else if (e.target.classList[0] == "context-delete" || e.target?.parentElement?.classList[0] == "context-delete") {
      this.connectionRemove.emit(this.selectedConnection)
      this.flowchart.removeSingleConnection(this.selectedConnection.output_id, this.selectedConnection.input_id, this.selectedConnection.output_class, this.selectedConnection.input_class)
    } else if (e.target.classList[0] == "context-edit" || e.target?.parentElement?.classList[0] == "context-edit") {
      this.connectionSelected.emit({ selectedConnection: this.selectedConnection, flow: this.flowchart.export() })

    }

  }

  showConextMenu(x, y) {
    var pos_x = x * (this.flowchart.precanvas.clientWidth / (this.flowchart.precanvas.clientWidth * this.flowchart.zoom)) - (this.flowchart.precanvas.getBoundingClientRect().x * (this.flowchart.precanvas.clientWidth / (this.flowchart.precanvas.clientWidth * this.flowchart.zoom)));
    var pos_y = y * (this.flowchart.precanvas.clientHeight / (this.flowchart.precanvas.clientHeight * this.flowchart.zoom)) - (this.flowchart.precanvas.getBoundingClientRect().y * (this.flowchart.precanvas.clientHeight / (this.flowchart.precanvas.clientHeight * this.flowchart.zoom)));

    var contextmenu = document.createElement('div');
    contextmenu.id = "contextmenu";
    contextmenu.innerHTML = `<div class="contextmenu-container">
    <button class="context-delete">
    <svg width="64px" height="64px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M905.92 237.76a32 32 0 0 0-52.48 36.48A416 416 0 1 1 96 512a418.56 418.56 0 0 1 297.28-398.72 32 32 0 1 0-18.24-61.44A480 480 0 1 0 992 512a477.12 477.12 0 0 0-86.08-274.24z" fill="#231815"></path><path d="M630.72 113.28A413.76 413.76 0 0 1 768 185.28a32 32 0 0 0 39.68-50.24 476.8 476.8 0 0 0-160-83.2 32 32 0 0 0-18.24 61.44zM489.28 86.72a36.8 36.8 0 0 0 10.56 6.72 30.08 30.08 0 0 0 24.32 0 37.12 37.12 0 0 0 10.56-6.72A32 32 0 0 0 544 64a33.6 33.6 0 0 0-9.28-22.72A32 32 0 0 0 505.6 32a20.8 20.8 0 0 0-5.76 1.92 23.68 23.68 0 0 0-5.76 2.88l-4.8 3.84a32 32 0 0 0-6.72 10.56A32 32 0 0 0 480 64a32 32 0 0 0 2.56 12.16 37.12 37.12 0 0 0 6.72 10.56zM726.72 297.28a32 32 0 0 0-45.12 0l-169.6 169.6-169.28-169.6A32 32 0 0 0 297.6 342.4l169.28 169.6-169.6 169.28a32 32 0 1 0 45.12 45.12l169.6-169.28 169.28 169.28a32 32 0 0 0 45.12-45.12L557.12 512l169.28-169.28a32 32 0 0 0 0.32-45.44z" fill="#231815"></path></g></svg>
    <span>${this.translate.instant("Common.Delete")}</span></button>
    <button class="context-edit">
    <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
    <span>${this.translate.instant("FlowPage.ChangeRule")}</span></button></div>`;
    contextmenu.style.display = "block";

    contextmenu.style.left = pos_x + "px";
    contextmenu.style.top = pos_y + "px";


    this.flowchart.precanvas.appendChild(contextmenu);

  }

  unShowConextMenu() {
    var contextmenu = document.getElementById('contextmenu')
    if (contextmenu != null) {
      contextmenu.remove();
    }

  }


  initDrawFlow() {
    this.flowchart = new Drawflow(document.getElementById('drawflowDiv'));
    this.flowchart.start();



    this.flowchart.on('connectionSelected', (e) => {
      console.log(e)
      this.selectedConnection = e
      // this.connectionSelected.emit({ selectedConnection: e, flow: this.flowchart.export() })

    })

    this.flowchart.on('connectionCreated', (e) => {
      this.selectedConnection = e
      this.connectionSelected.emit({ selectedConnection: this.selectedConnection, flow: this.flowchart.export(), conName: 'default' })


    })





    this.flowchart.on('import', () => {
      this.onImport.emit()
    })

    this.flowchart.on('click', (e: any) => {

      this.flowChartClick(e)
      var contextmenu = document.getElementById('contextmenu')

      if (contextmenu != null) {
        contextmenu.remove();
      }

    });


    this.flowchart.on('nodeRemoved', (e: any) => {

      this.NodeRemovedEmitter.emit(e)

    });






    this.flowchart.createCurvature = (start_pos_x, start_pos_y, end_pos_x, end_pos_y, curvature_value, type) => {
      var line_x = start_pos_x;
      var line_y = start_pos_y;

      var x = end_pos_x;
      var y = end_pos_y;
      var curvature = curvature_value;
      //type openclose open close other
      switch (type) {
        case 'open':
          if (start_pos_x >= end_pos_x) {
            var hx1 = line_x + Math.abs(x - line_x) * curvature;
            var hx2 = x - Math.abs(x - line_x) * (curvature * -1);
          } else {
            var hx1 = line_x + Math.abs(x - line_x) * curvature;
            var hx2 = x - Math.abs(x - line_x) * curvature;
          }
          return ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + hx2 + ' ' + y + ' ' + x + '  ' + y;

          break
        case 'close':
          if (start_pos_x >= end_pos_x) {
            var hx1 = line_x + Math.abs(x - line_x) * (curvature * -1);
            var hx2 = x - Math.abs(x - line_x) * curvature;
          } else {
            var hx1 = line_x + Math.abs(x - line_x) * curvature;
            var hx2 = x - Math.abs(x - line_x) * curvature;
          }                                                                                                                  //M0 75H10L5 80L0 75Z

          return ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + hx2 + ' ' + y + ' ' + x + '  ' + y + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 5) + '  L' + (x - 20) + ' ' + (y + 5) + 'Z';
          break;
        case 'other':
          if (start_pos_x >= end_pos_x) {
            var hx1 = line_x + Math.abs(x - line_x) * (curvature * -1);
            var hx2 = x - Math.abs(x - line_x) * (curvature * -1);
          } else {
            var hx1 = line_x + Math.abs(x - line_x) * curvature;
            var hx2 = x - Math.abs(x - line_x) * curvature;
          }
          return ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + hx2 + ' ' + y + ' ' + x + '  ' + y;
          break;
        default:

          var hx1 = line_x + Math.abs(x - line_x) * curvature;
          var hx2 = x - Math.abs(x - line_x) * curvature;

          //return ' M '+ line_x +' '+ line_y +' C '+ hx1 +' '+ line_y +' '+ hx2 +' ' + y +' ' + x +'  ' + y;
          return ' M ' + line_x + ' ' + line_y + ' C ' + hx1 + ' ' + line_y + ' ' + hx2 + ' ' + y + ' ' + x + '  ' + y + ' M ' + (x - 11) + ' ' + y + ' L' + (x - 20) + ' ' + (y - 5) + '  L' + (x - 20) + ' ' + (y + 5) + 'Z';
      }

    }


  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.Nodes && this.Nodes.length > 0) {

      if (changes.Nodes.previousValue[changes.Nodes.previousValue.length - 1]?.nodeId !== this.Nodes[this.Nodes.length - 1]?.nodeId)
        this.addNodeToDrawBoard(this.Nodes[this.Nodes.length - 1].pos_x, this.Nodes[this.Nodes.length - 1].pos_y, this.Nodes[this.Nodes.length - 1].item)
    }

    // var changesobj = this.findChanges(changes.Nodes.currentValue, changes.Nodes.previousValue)
    // if (changesobj)
    //   console.log(changes.Nodes)


    if (changes.flowImportObject)
      this.initExistFlow()




  }

  findChanges(oldArray, newArray) {
    const changes = [];

    // Dizilerin her bir öğesini kontrol et
    oldArray.forEach((oldItem, index) => {
      const newItem = newArray[index];

      // İki öğeyi karşılaştır
      if (!this.areObjectsEqual(oldItem, newItem)) {
        changes.push({ oldItem, newItem, index });
      }
    });

    return changes;
  }

  areObjectsEqual(obj1, obj2) {
    // Bu örnekte objelerin basit bir karşılaştırması yapılıyor
    // Daha karmaşık bir karşılaştırma yapmanız gerekiyorsa bu fonksiyonu özelleştirebilirsiniz
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  zoom(type: string) {
    if (type == 'in')
      this.flowchart.zoom_out();
    else
      this.flowchart.zoom_in();

  }


  addNodeToDrawBoard(pos_x: number, pos_y: number, item: FlowScriptResponse) {
    item.nodeId = 'node-' + this.flowchart.nodeId
    if (this.flowchart?.editor_mode === 'edit') {
      pos_x =
        pos_x * (this.flowchart.precanvas.clientWidth / (this.flowchart.precanvas.clientWidth * this.flowchart.zoom)) -
        this.flowchart.precanvas.getBoundingClientRect().x *
        (this.flowchart.precanvas.clientWidth / (this.flowchart.precanvas.clientWidth * this.flowchart.zoom));

      pos_y =
        pos_y * (this.flowchart.precanvas.clientHeight / (this.flowchart.precanvas.clientHeight * this.flowchart.zoom)) -
        this.flowchart.precanvas.getBoundingClientRect().y *
        (this.flowchart.precanvas.clientHeight / (this.flowchart.precanvas.clientHeight * this.flowchart.zoom));
      var htmlTemplate = ''
      if (item.parameters.length > 0) {
        htmlTemplate = `<div class="custom-card-container">
        <div class="custom-card-nodeid">${'node-' + this.flowchart.nodeId}</div>
        <div class="top-section">
            <div class="img-info">
                <div class="card-img">
                    <img src="${environment.baseUrl + item.icon}" onerror="this.src='/assets/images/python.svg'"/>
                </div>
                <div class="card-info">
                    <span class="bottom-title">${item.name}</span>
                </div>
            </div>
            <div class="action-area">
          <svg class="parameter-button" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="3" stroke="#5E6DA6" stroke-width="1.5"></circle> <path d="M3.66122 10.6392C4.13377 10.9361 4.43782 11.4419 4.43782 11.9999C4.43781 12.558 4.13376 13.0638 3.66122 13.3607C3.33966 13.5627 3.13248 13.7242 2.98508 13.9163C2.66217 14.3372 2.51966 14.869 2.5889 15.3949C2.64082 15.7893 2.87379 16.1928 3.33973 16.9999C3.80568 17.8069 4.03865 18.2104 4.35426 18.4526C4.77508 18.7755 5.30694 18.918 5.83284 18.8488C6.07287 18.8172 6.31628 18.7185 6.65196 18.5411C7.14544 18.2803 7.73558 18.2699 8.21895 18.549C8.70227 18.8281 8.98827 19.3443 9.00912 19.902C9.02332 20.2815 9.05958 20.5417 9.15224 20.7654C9.35523 21.2554 9.74458 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8478 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.9021C15.0117 19.3443 15.2977 18.8281 15.7811 18.549C16.2644 18.27 16.8545 18.2804 17.3479 18.5412C17.6837 18.7186 17.9271 18.8173 18.1671 18.8489C18.693 18.9182 19.2249 18.7756 19.6457 18.4527C19.9613 18.2106 20.1943 17.807 20.6603 17C20.8677 16.6407 21.029 16.3614 21.1486 16.1272M20.3387 13.3608C19.8662 13.0639 19.5622 12.5581 19.5621 12.0001C19.5621 11.442 19.8662 10.9361 20.3387 10.6392C20.6603 10.4372 20.8674 10.2757 21.0148 10.0836C21.3377 9.66278 21.4802 9.13092 21.411 8.60502C21.3591 8.2106 21.1261 7.80708 20.6601 7.00005C20.1942 6.19301 19.9612 5.7895 19.6456 5.54732C19.2248 5.22441 18.6929 5.0819 18.167 5.15113C17.927 5.18274 17.6836 5.2814 17.3479 5.45883C16.8544 5.71964 16.2643 5.73004 15.781 5.45096C15.2977 5.1719 15.0117 4.6557 14.9909 4.09803C14.9767 3.71852 14.9404 3.45835 14.8478 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74458 2.35523 9.35523 2.74458 9.15224 3.23463C9.05958 3.45833 9.02332 3.71848 9.00912 4.09794C8.98826 4.65566 8.70225 5.17191 8.21891 5.45096C7.73557 5.73002 7.14548 5.71959 6.65205 5.4588C6.31633 5.28136 6.0729 5.18269 5.83285 5.15108C5.30695 5.08185 4.77509 5.22436 4.35427 5.54727C4.03866 5.78945 3.80569 6.19297 3.33974 7C3.13231 7.35929 2.97105 7.63859 2.85138 7.87273" stroke="#5E6DA6" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>

            <svg class="script-edit-button" fill="#5E6DA6" version="1.0" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 96.000000 96.000000"
              preserveAspectRatio="xMidYMid meet">
        
             <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
              stroke="#5E6DA6">
             <path d="M739 873 c-38 -36 -69 -75 -69 -85 0 -32 29 -33 61 -2 l29 28 30 -29
             30 -29 -76 -77 c-57 -57 -87 -80 -116 -87 l-40 -10 7 36 c3 20 20 51 36 67 33
             35 36 47 13 66 -14 11 -22 7 -58 -31 -34 -36 -45 -57 -55 -107 -20 -94 5 -111
             115 -78 42 12 67 33 177 143 117 119 127 132 127 166 0 54 -44 96 -100 96 -38
             0 -48 -6 -111 -67z m147 -19 c4 -17 1 -31 -10 -42 -15 -15 -18 -14 -42 10 -33
             33 -26 58 15 58 25 0 32 -5 37 -26z"/>
             <path d="M178 824 c-55 -29 -58 -48 -58 -344 0 -298 3 -316 60 -345 41 -21
             242 -21 260 0 10 12 10 18 0 30 -10 12 -37 15 -121 15 -84 0 -111 3 -123 16
             -14 13 -16 53 -16 282 0 150 4 274 10 282 7 12 44 16 192 20 l183 5 0 25 0 25
             -180 2 c-144 2 -185 -1 -207 -13z"/>
             <path d="M792 578 c-8 -8 -12 -65 -12 -187 0 -97 -5 -183 -10 -191 -7 -11 -36
             -16 -117 -20 -107 -5 -108 -5 -108 -30 0 -25 1 -25 102 -28 78 -2 110 1 133
             13 54 28 60 55 60 253 0 169 -5 202 -30 202 -3 0 -11 -5 -18 -12z"/>
             </g>
             </svg>
            </div>
        </div>
        <div class="bottom-section">
            <div class="bottom-text">
                <div class="small-text">${item.description}</div>
            </div>
        </div>
    </div>`;
      } else {
        htmlTemplate = `<div class="custom-card-container">
        <div class="custom-card-nodeid">${'node-' + this.flowchart.nodeId}</div>
        <div class="top-section">
            <div class="img-info">
                <div class="card-img">
                    <img src="${environment.baseUrl + item.icon}" onerror="this.src='/assets/images/python.svg'"/>
                </div>
                <div class="card-info">
                    <span class="bottom-title">${item.name}</span>
                </div>
            </div>
            <div class="action-area">
            <svg class="script-edit-button" fill="#5E6DA6" version="1.0" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" viewBox="0 0 96.000000 96.000000"
              preserveAspectRatio="xMidYMid meet">
        
             <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
              stroke="#5E6DA6">
             <path d="M739 873 c-38 -36 -69 -75 -69 -85 0 -32 29 -33 61 -2 l29 28 30 -29
             30 -29 -76 -77 c-57 -57 -87 -80 -116 -87 l-40 -10 7 36 c3 20 20 51 36 67 33
             35 36 47 13 66 -14 11 -22 7 -58 -31 -34 -36 -45 -57 -55 -107 -20 -94 5 -111
             115 -78 42 12 67 33 177 143 117 119 127 132 127 166 0 54 -44 96 -100 96 -38
             0 -48 -6 -111 -67z m147 -19 c4 -17 1 -31 -10 -42 -15 -15 -18 -14 -42 10 -33
             33 -26 58 15 58 25 0 32 -5 37 -26z"/>
             <path d="M178 824 c-55 -29 -58 -48 -58 -344 0 -298 3 -316 60 -345 41 -21
             242 -21 260 0 10 12 10 18 0 30 -10 12 -37 15 -121 15 -84 0 -111 3 -123 16
             -14 13 -16 53 -16 282 0 150 4 274 10 282 7 12 44 16 192 20 l183 5 0 25 0 25
             -180 2 c-144 2 -185 -1 -207 -13z"/>
             <path d="M792 578 c-8 -8 -12 -65 -12 -187 0 -97 -5 -183 -10 -191 -7 -11 -36
             -16 -117 -20 -107 -5 -108 -5 -108 -30 0 -25 1 -25 102 -28 78 -2 110 1 133
             13 54 28 60 55 60 253 0 169 -5 202 -30 202 -3 0 -11 -5 -18 -12z"/>
             </g>
             </svg>
            </div>
        </div>
        <div class="bottom-section">
            <div class="bottom-text">
                <div class="small-text">${item.description}</div>
            </div>
        </div>
    </div>`;
      }
      this.flowchart.addNode(
        'node-' + this.flowchart.nodeId,
        1,
        1,
        pos_x,
        pos_y,
        'custom-draw-flow-card',
        item,
        htmlTemplate,
        false
      );

    }
  }

  clickSetting(item) {
    console.log(item)
  }

  saveFlow() {
    this.SaveFlowEmitter.emit(this.flowchart.export())
  }

  runFlow() {
    this.runFlowEmitter.emit(this.flowchart.export())

  }

  getExecutionLog() {
    this.getExecutionLogFunc.emit()
  }
  routeToFLow() {
    this.router.navigate(["/flow"])

  }
  stopFlow() {
    this.stopButtonFunction.emit()
  }

}
